import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import RetailerPermissions from '../../components/blocks/RetailerPermissions';
import Spinner from '../../components/common/Spinner/Spinner';
import {
  setDropshipRevenue,
  putPermissions,
  setDropshipAllowed,
  setReplenishAllowed,
  setPermissionsMinimumOrderProducts,
  setPermissionsMinimumOrderValue,
  setPermissionsFixedPerUnit,
  setPermissionsPercentage,
  setReplenishDaysUntilOverdue,
  setEcommerceDaysUntilOverdue,
  setPermissionsChanged,
} from '../../store/actions/permissions';

function RetailerPermissionContainer(props) {
  if (props.isLoading) {
    return <Spinner />;
  }

  return <RetailerPermissions {...props} key={props.id} />;
}

const mapStateToProps = ({ retailer, permissions, role }) => {
  const { isLoading } = retailer;
  const hasStripe = role.supplier?.stripe_publishable_key !== null;
  const orderType = permissions.retailer ? permissions.retailer.order_type : null;
  const is_super_admin = role.user.is_super_admin && ['support', 'admin'].includes(role.user.role);

  const {
    ecommerce_billing_method,
    replenish_billing_method,
    ecommerce_unit_price_formula,
    approved_for_ecommerce,
    approved_for_replenishment,
    changed,
    minimum_products_for_replenishment_order,
    minimum_order_value_for_replenishment_order,
    replenishment_order_shipping_cost_percentage,
    replenishment_order_shipping_cost_fixed_per_unit,
    replenishment_shipper_account_type,
    replenishment_shipper_account,
    ecommerce_send_invoice,
    ecommerce_invoice_net_plus,
    replenish_send_invoice,
    replenish_invoice_net_plus,
    settings,
    refund_cost_formula,
    handling_fee_formula,
    payment_cycle,
  } = permissions;

  return {
    ecommerce_billing_method,
    replenish_billing_method,
    ecommerce_unit_price_formula,
    approved_for_ecommerce,
    approved_for_replenishment,
    changed,
    minimum_products_for_replenishment_order,
    minimum_order_value_for_replenishment_order,
    replenishment_order_shipping_cost_percentage,
    replenishment_order_shipping_cost_fixed_per_unit,
    replenishment_shipper_account_type,
    replenishment_shipper_account,
    has_stripe: hasStripe,
    ecommerce_send_invoice,
    ecommerce_invoice_net_plus,
    replenish_send_invoice,
    replenish_invoice_net_plus,
    isLoading,
    order_type: orderType,
    settings,
    refund_cost_formula,
    handling_fee_formula,
    is_super_admin,
    payment_cycle,
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeDropshipAllowed: (value) => dispatch(setDropshipAllowed(value)),
  changeReplenishAllowed: (value) => dispatch(setReplenishAllowed(value)),
  changeDropshipRevenue: (commission_type, value) => dispatch(setDropshipRevenue(commission_type, value)),
  changeReplenishDaysUntilOverdue: (value) => dispatch(setReplenishDaysUntilOverdue(value)),
  changeEcommerceDaysUntilOverdue: (value) => dispatch(setEcommerceDaysUntilOverdue(value)),
  putPermissions: (id, data) => dispatch(putPermissions(id, data)),
  setPermissionsMinimumOrderProducts: (value) => dispatch(setPermissionsMinimumOrderProducts(value)),
  setPermissionsMinimumOrderValue: (value) => dispatch(setPermissionsMinimumOrderValue(value)),
  setPermissionsFixedPerUnit: (value) => dispatch(setPermissionsFixedPerUnit(value)),
  setPermissionsPercentage: (value) => dispatch(setPermissionsPercentage(value)),
  setPermissionsChanged: (value = true) => dispatch(setPermissionsChanged(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RetailerPermissionContainer);

RetailerPermissionContainer.propTypes = {
  id: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
